export const TAUX_PLEIN = 0.0920
export const TAUX_DEDUCTIBLE = 0.0680
export const ABATTEMENT_FRAIS_PRO = 0.0175

export const PLAFOND_ASSIETTE_REDUITE = 185472
export const TAUX_ASSIETTE_REDUITE = 0.9825

export const TAUX_CRDS = 0.005
